import { render, staticRenderFns } from "./AboutBee.vue?vue&type=template&id=d9a5d868&"
import script from "./AboutBee.vue?vue&type=script&lang=js&"
export * from "./AboutBee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports